import { render, staticRenderFns } from "./TablePhieuThayDoiThongTin.vue?vue&type=template&id=6f83bda8&scoped=true&"
import script from "./TablePhieuThayDoiThongTin.vue?vue&type=script&lang=js&"
export * from "./TablePhieuThayDoiThongTin.vue?vue&type=script&lang=js&"
import style0 from "./TablePhieuThayDoiThongTin.vue?vue&type=style&index=0&id=6f83bda8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f83bda8",
  null
  
)

export default component.exports